import { createFileRoute } from "@tanstack/react-router";
import { EditFacturePage } from "@/features/achats/components/factures/EditFacturePage";

export const Route = createFileRoute("/_app/achats/factures/$id/edit")({
  staticData: {
    title: "Modifier facture",
    showInBreadcrumb: true,
  },
  component: EditFacturePage,
});
